import { Navbar, Footer } from "@/components/landing";
import { ProcessContent } from "@/components/process/ProcessContent";

export function ProcessPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <div className="h-24 lg:h-28" aria-hidden="true" />
        <ProcessContent />
      </main>
      <Footer />
    </div>
  );
}
